'use client'
import Image from "next/image"
import { useTranslations } from "next-intl";
import useFetchPosts from "./fetcher";
import { useLocale } from "next-intl";
import Link from "next/link";

export default function PostSideId(i: any) {
  const l = useLocale();
  const t1 = useTranslations('Blog-id');
  const { posts, error, isLoading } = useFetchPosts();
  
  const getLocalizedField = (item: any, field: string) => 
    item[`${field}_${l}`] || item[`${field}_en`];
  
  const filteredProducts = posts?.filter(
    (product) => product.id !== i.i
  );

  // Single multilingual promotional image
  const promoImage = {
    src_en: "/notbook/en.avif",
    src_ar: "/notbook/ar.avif",
    src_de: "/notbook/de.avif",
    src_es: "/notbook/es.avif",
    src_fr: "/notbook/fr.avif",
    src_it: "/notbook/it.avif",
    src_nl: "/notbook/nl.avif",
    src_pt: "/notbook/pt.avif",
    src_ru: "/notbook/ru.avif",
    src_sv: "/notbook/sv.avif",
    alt_en: "Padel Guide Book",
    alt_ar: "دليل البادل",
    alt_de: "Padel-Leitfaden",
    alt_es: "Guía de Pádel",
    alt_fr: "Guide de Padel",
    alt_it: "Guida al Padel",
    alt_nl: "Padel Gids",
    alt_pt: "Guia de Padel",
    alt_ru: "Руководство по паделу",
    alt_sv: "Padel Guide",
    link_en: "https://www.amazon.com/dp/B0GN9T81HX",
    link_ar: "https://www.amazon.com/dp/B0H4QT2NLN",
    link_de: "https://www.amazon.de/dp/B0H5BN7KSY",
    link_es: "https://www.amazon.es/dp/B0HDJ4CW6X",
    link_fr: "https://www.amazon.fr/dp/B0H4ZJNM2D",
    link_it: "https://www.amazon.it/dp/B0GN9T81HX",
    link_nl: "https://www.amazon.nl/dp/B0GN9T81HX",
    link_pt: "https://www.amazon.com.be/dp/B0H4ZW68RG",
    link_ru: "https://www.amazon.com/dp/B0GN9T81HX",
    link_sv: "https://www.amazon.se/dp/B0GN9T81HX"
  };

  const SkeletonLoader = () => (
    <div className="mx-3 sm:mx-20 lg:mx-0 lg:col-span-2">
      <div>
        {[...Array(4)].map((_, index) => (
          <div key={index} className="mb-5">
            <div className="flex gap-5 items-center">
              <div className="relative h-24 md:h-40 lg:h-24 w-[500px] bg-gray-200 rounded animate-pulse"></div>
              <div className="h-6 w-[700px] bg-gray-200 rounded animate-pulse"></div>
            </div>
            <div className="border-spacing-1 my-5 border-t border-gray-200"></div>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="mx-3 sm:mx-20 lg:mx-0 lg:col-span-2">
      <h4 className="text-lg font-bold capitalize mb-3">
        {t1('Explore More from Padelv')}
      </h4>
      
      {isLoading ? (
        <SkeletonLoader />
      ) : error ? (
        <SkeletonLoader />
      ) : (
        <div>
          {filteredProducts.slice(0, 4).map((item) => (
            <div key={item.id}>
              <Link href={`/${l}/blog/${getLocalizedField(item, "url")}`}>
                <div className="flex gap-5 items-center">
                  <div className="relative h-24 md:h-40 lg:h-24 w-[500px] rounded-lg overflow-hidden">
                    <Image
                      src={`${process.env.NEXT_PUBLIC_IMAGE}/${getLocalizedField(item, "image")}`}
                      alt={getLocalizedField(item, "tag")}
                      fill
                      sizes="(max-width: 768px) 100vw, 50vw"
                      style={{ objectFit: "cover" }}
                      className="z-0"
                      priority
                    />
                  </div>
                  <h2 className="text-lg w-[700px] hover:text-bl hover:underline">
                    {getLocalizedField(item, "title")}
                  </h2>
                </div>
              </Link>
              <hr className="border-spacing-1 my-5" />
            </div>
          ))}
        </div>
      )}

      {/* Localized Promotional Image with Link */}
      <Link href={getLocalizedField(promoImage, "link")} target="_blank"
  rel="noopener noreferrer">
        <div className="relative h-[500px] w-full mb-4 rounded-lg overflow-hidden hover:opacity-90 transition-opacity">
          <Image
            src={getLocalizedField(promoImage, "src")}
            alt={getLocalizedField(promoImage, "alt")}
            fill
            sizes="(max-width: 768px) 100vw, 50vw"
            style={{ objectFit: "contain" }}
            className="z-0"
            priority
          />
        </div>
      </Link>
    </div>
  );
}